//user 用户
export const SET_USER_INFO      = 'SETUSERINFO'      //设置用户信息
export const SET_LOGIN_STATUS   = 'SET_LOGIN_STATUS' //设置登录状态

//basic  基础数据主要是（性别、证件类型、文化程度、职业、关系类型）
export const SET_BASIC_OCCUPATIONS='SET_BASIC_OCCUPATIONS'
export const SET_BASIC_RELATIONS='SET_BASIC_RELATIONS'
export const SET_BASIC_SEXES='SET_BASIC_SEXES'
export const SET_BASIC_CARD_TYPES='SET_BASIC_CARD_TYPES'
export const SET_BASIC_EDUCATIONS='SET_BASIC_EDUCATIONS'

//survey 调查问卷
export const GET_SURVEY='GET_SURVEY'
export const SET_SURVEY_PAGE_INDEX='SET_SURVEY_PAGE_INDEX'
export const SET_SURVEY_QUESTIONS='GET_SURVEY_QUESTIONS'
export const SET_SURVEY_ANSWERS='SET_SURVEY_ANSWERS'
export const SET_SURVEY_PAGE_NEXT='SET_SURVEY_PAGE_NEXT'
export const SET_SURVEY_PAGE_PREVIOUS='SET_SURVEY_PAGE_PREVIOUS'


// WEBPACK FOOTER //
// ./src/vuex/types.js